module.exports = __webpack_public_path__ + "img/dragster-neon.f1c350a2.png";